import shopifyGenericDefaults from '../shopify-generic/config.js';

const getItemId = ({ getItemId, getVariantId }) => {
  if (window.document.querySelector('.product-options')) {
    const variantId = getVariantId();
    if (variantId) {
      return variantId;
    }
  }

  return getItemId();
};

const InitFunc = () => {
  shopifyGenericDefaults.InitFunc?.();

  // Wait until the page is fully loaded because variants are dynamically added via script.
  window.addEventListener('load', () => {
    const optionSelectors = window.document.querySelectorAll(
      'body.template-product .variants-wrapper select.js-variant-change',
    );

    optionSelectors?.forEach((element) => {
      element.addEventListener('change', () => {
        setTimeout(() => {
          const variantId = window.Convermax.Shopify.getVariantId();
          if (variantId) {
            window.Convermax.updateVerifyFitmentWidget(variantId);
          }
        }, 300);
      });
    });
  });
};

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  InitFunc,
  product: {
    ...shopifyGenericDefaults.product,
    getItemId,
  },
};
